import script from "./MoveToProjectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveToProjectModal.vue?vue&type=script&setup=true&lang=js"

import "./MoveToProjectModal.vue?vue&type=style&index=0&id=8b09c882&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b09c882"]])

export default __exports__